import { render, staticRenderFns } from "./pbx-view.vue?vue&type=template&id=2aea4878&"
import script from "./pbx-view.vue?vue&type=script&lang=ts&"
export * from "./pbx-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports